import React from 'react'
import CustomNav from '../components/CustomNav'
import CardItem from '../components/CardItem'
import img from "../images/professional.webp"
import img1 from "../images/solr.jpeg"
import Footer from '../components/Footer'
import NewNav from '../components/NewNav'
import "../NewNav.scss";



function Projects() {
  return (
    <div className='project-wraper'>
     <NewNav/>
    <div className="conatiner mt-5" style={{maxWidth:"1200px", margin:"auto" ,overflow: "hidden"}}>
        <div className="row">
            <div className="col-md-4 mb-4">
            <CardItem
          id="card1"
          imageSrc={img}
          title="Peshawar project"
          description="Peshawar project with fwo 1100 lights osram 180watt Wirh lighting poles 120 million projext 61 months completion within time span"
        />
            </div>
            <div className="col-md-4 mb-4">
            <CardItem
          id="card2"
          imageSrc={img1}
          title="Faisalabad project"
          description="Faisalabad project with muncipal corporation Osram 30watt and 60watt UCs 16 8500 lights 120 million Completed within 6 months supply only"
        />
            </div>     
        </div>
    </div>
    
       
<Footer/>
  
    </div>
  )
}

export default Projects